import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { OBJECT_getInstance167untwb9admi as OBJECT_getInstance } from '../descriptors/SerialKinds.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../descriptors/SerialDescriptor.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function error($this) {
  throw IllegalStateException().o('Descriptor for type `kotlin.Nothing` does not have elements');
}
var NothingSerialDescriptorClass;
function NothingSerialDescriptor() {
  if (NothingSerialDescriptorClass === VOID) {
    class $ {
      constructor() {
        NothingSerialDescriptor_instance = this;
        this.m1z_1 = OBJECT_getInstance();
        this.n1z_1 = 'kotlin.Nothing';
      }
      d1p() {
        return this.m1z_1;
      }
      k1n() {
        return this.n1z_1;
      }
      f1p() {
        return 0;
      }
      h1p(index) {
        error(this);
      }
      i1p(name) {
        error(this);
      }
      l1p(index) {
        error(this);
      }
      k1p(index) {
        error(this);
      }
      j1p(index) {
        error(this);
      }
      toString() {
        return 'NothingSerialDescriptor';
      }
      equals(other) {
        return this === other;
      }
      hashCode() {
        return getStringHashCode(this.n1z_1) + imul(31, this.m1z_1.hashCode()) | 0;
      }
    }
    protoOf($).w1o = get_isNullable;
    protoOf($).e1p = get_isInline;
    protoOf($).g1p = get_annotations;
    initMetadataForObject($, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    NothingSerialDescriptorClass = $;
  }
  return NothingSerialDescriptorClass;
}
var NothingSerialDescriptor_instance;
function NothingSerialDescriptor_getInstance() {
  if (NothingSerialDescriptor_instance === VOID)
    new (NothingSerialDescriptor())();
  return NothingSerialDescriptor_instance;
}
//region block: exports
export {
  NothingSerialDescriptor_getInstance as NothingSerialDescriptor_getInstance2zwo7fzw0h0j,
};
//endregion

//# sourceMappingURL=NothingSerialDescriptor.mjs.map
